import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { filterPropName } from '../helper/object'
import { sendContactForm } from '../actions/sendContactForm'
import './contactForm.css'

export class ContactForm extends React.Component {
	static propTypes = {
		onSend: PropTypes.func.isRequired,
	}
	state = {
		Name: '',
		Straße: '',
		PLZ: '',
		Ort: '',
		Telefon: '',
		Email: '',
		Text: '',
	}
	update = ({target: {name, value}}) =>
		this.setState({[name]: value})
	send = () => {
		const MailProps = ['Name', 'Straße', 'PLZ', 'Ort', 'Telefon', 'Email', 'Text']
		this.setState({sendingStatus: 'sending'})
		this.props.onSend(filterPropName(this.state, MailProps))
			.then(() => this.setState({sendingStatus: 'send'}))
			.catch(() => this.setState({sendingStatus: 'error'}))
	}
	render(){
		const {
			Name,
			Straße,
			PLZ,
			Ort,
			Telefon,
			Email,
			Text,
			sendingStatus,
		} = this.state
		const isDisabled = sendingStatus === 'send' || sendingStatus === 'sending'
		return <div className="contactForm">
			<label htmlFor="contactFormName">Name:</label>
			<input name="Name" id="contactFormName" value={Name}
				onChange={this.update} disabled={isDisabled} />
			<label htmlFor="contactFormStraße">Straße:</label>
			<input name="Straße" id="contactFormStraße" value={Straße}
				onChange={this.update} disabled={isDisabled} />
			<label htmlFor="contactFormPLZ" className="small">PLZ/</label>
			<label htmlFor="contactFormOrt" className="small">Ort:</label>
			<input name="PLZ" id="contactFormPLZ" value={PLZ}
				onChange={this.update} disabled={isDisabled} className="small" />
			<input name="Ort" id="contactFormOrt" value={Ort}
				onChange={this.update} disabled={isDisabled} className="small" />
			<label htmlFor="contactFormTelefon">Telefon:</label>
			<input name="Telefon" id="contactFormTelefon" value={Telefon}
				onChange={this.update} disabled={isDisabled} />
			<label htmlFor="contactFormEmail">Email:</label>
			<input name="Email" id="contactFormEmail" value={Email}
				onChange={this.update} disabled={isDisabled} />
			<label htmlFor="contactFormText">Text:</label>
			<textarea name="Text" id="contactFormText" value={Text}
				onChange={this.update} disabled={isDisabled} />
			<button onClick={this.send} disabled={isDisabled}>Send</button>
			{sendingStatus === 'send' && <span>Email wurde versendet</span>}
			{sendingStatus === 'error' && <span>Senden fehlgeschlagen! Bitte versuchen Sie es später erneut.</span>}
		</div>
	}
}

export const mapStateToProps = () => ({})

export const mapDispatchToProps = sendContactForm => dispatch => ({
	onSend: data => dispatch(sendContactForm(data)),
})

export default connect(mapStateToProps, mapDispatchToProps(sendContactForm))(ContactForm)



// WEBPACK FOOTER //
// ./src/components/contactForm.jsx